import React, {Component} from 'react'
import {Card} from 'reactstrap'
import {Route, Switch} from 'react-router-dom'
import CompaniesList from '../../components/Companies/Companies'
import Company from '../../components/Companies/Company'

export default class Companies extends Component {

  render() {
    return (
      <div className="animated fadeIn">
        <Card>
          <Switch>
            <Route exact path="/companies" component={CompaniesList}/>
            <Route exact path="/companies/:id" component={Company}/>
          </Switch>
        </Card>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Companies/Companies.js